import TR from 'utils/TR';
import React from 'react';
import T from 'utils/T';
import ex from 'utils/ex';
import * as Luxon from 'luxon';
import FocusableButton from 'components/common/FocusableButton';
import { luxonClone, luxonDiffDay } from 'utils/time';
import WEEK_DAY_COLUMNS from 'constants/WEEK_DAY_COLUMNS';

const Period = (props) => {
  const {
    selection_start,
    selection_end,
  } = props || {};
  const date_start = React.useMemo(() => selection_start.toFormat('M.d'), [selection_start]);
  const date_end = React.useMemo(() => selection_end.toFormat('M.d'), [selection_end]);
  const diff_days = React.useMemo(() => luxonDiffDay(selection_start, selection_end), [selection_start, selection_end]);

  const weekday_start = React.useMemo(() => luxonClone(selection_start).weekday, [selection_start]);
  const weekday_end = React.useMemo(() => luxonClone(selection_end).weekday, [selection_end]);
  return T('{0} ({1}) ~ {2} ({3}) - {4}일 선택', date_start, WEEK_DAY_COLUMNS[weekday_start - 1], date_end, WEEK_DAY_COLUMNS[weekday_end - 1], Math.floor(diff_days) + 1);
}

export default function PeriodSetButton(props) {
  const {
    selection_start,
    selection_end,
    ...rest
  } = props || {};
  const disabled = !selection_start || !selection_end;
  return (
    <FocusableButton
      {...ex('PeriodSetButton', rest)}
      {...{ disabled }}
    >
      {disabled && (
        T('기간선택')
      )}
      {!disabled && (
        <Period {...props} />
      )}
    </FocusableButton>
  );
}
